import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import { MapFilterEntityType } from "@mapmycustomers/shared/types/entity";

import { MAP_ENTITY_TYPES } from "@app/util/map/consts";

export const OPERATORS_ALLOWING_EMPTY_VALUE = [
  FilterOperator.EMPTY,
  FilterOperator.NOT_EMPTY,
  FilterOperator.IS_OVERDUE,
  FilterOperator.IS_UPCOMING,
  FilterOperator.IS_TRUE,
  FilterOperator.IS_FALSE,
];

export const FILTER_ENTITY_TYPES = ["universal", ...MAP_ENTITY_TYPES] as MapFilterEntityType[];
